import React from 'react'
import { Button } from '@refera/ui-web'

export function AddServiceButton({ handleAddServiceClick }) {
  // remove this section when add_internal_budget button action is created

  return (
    <Button variant="secondary" onClick={handleAddServiceClick} style={{ width: '160px' }}>
      + Adicionar serviço
    </Button>
  )
}
